import glamorous from "glamorous";
import themes from "../themes";

export default glamorous.button(
  {
    fontSize: 13,
    fontFamily: "Open Sans",
    backgroundColor: "inherit",
    border: "solid 1px",
    borderRadius: "50%",
    height: "50px",
    width: "50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    userSelect: "none",
    margin: "5px",
    opacity: .7,
    ":hover": {
      opacity: ".3"
    },
    ":active": {
      color: "blue"
    },
    ":focus": { outline: 0 }
  },
  props => {
    switch (props.theme) {
      case "dark": {
        return { color: themes[0].color2 } 
      }
      case "light": {
        return { color: themes[1].color2 }
      }
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/RoundButton.js